import { Input } from "antd";
import { InputProps } from "antd/lib";
import React from "react";
export const UI_ITOWithoutTrim = ({ onChange, ...props }: InputProps) => {
  const handleChange: InputProps["onChange"] = (e) => {
    e.target.value = e.target.value.trimStart();
    if (onChange) {
      onChange(e);
    }
  };
  return <Input onChange={handleChange} {...props} />;
};
